// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "[data-v-0e332fa4] .el-card__body{padding:15px}.czmj[data-v-0e332fa4]{color:#999;font-size:12px}.czmjNum[data-v-0e332fa4]{font-size:20px;margin-top:20px;padding-bottom:8px}.czl[data-v-0e332fa4]{font-size:12px;margin-top:10px}.ftzClor[data-v-0e332fa4]{color:#999}", ""]);
// Exports
module.exports = exports;
